import { render, staticRenderFns } from "./WindowsMaximizeIcon.vue?vue&type=template&id=10f8cac8&"
import script from "./WindowsMaximizeIcon.vue?vue&type=script&lang=js&"
export * from "./WindowsMaximizeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports